import React, { Component } from "react";
import OutsideClickFinder from "../../../../components/OutsideClickFinder";
import style from "../../faq.module.css";
import contactIcon from "../../../../images/faq-contact-form.svg";

export class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      subject: "",
      content: ""
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubjectChange = this.handleSubjectChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }
  handleSubjectChange(event) {
    this.setState({ subject: event.target.value });
  }
  handleMessageChange(event) {
    this.setState({ content: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.postForm(this.state);
  }

  render() {
    return (
      <div className={style.modal}>
        <OutsideClickFinder onOutsideClick={() => this.props.onOutsideClick()}>
          <div className={style.formContainer}>
            <img className={style.contactIcon} src={contactIcon} />
            <p className={style.contactTitle}>Submit Your Request</p>
            <form onSubmit={this.handleSubmit} style={{ width: "100%" }}>
              <input
                className={style.customInput}
                placeholder="Your Email"
                type="email"
                value={this.state.email}
                onChange={this.handleEmailChange}
                required={true}
              />
              <input
                className={style.customInput}
                placeholder="Subject..."
                type="text"
                value={this.state.subject}
                onChange={this.handleSubjectChange}
                required={true}
              />
              <textarea
                className={style.customTextArea}
                placeholder="Tell us how we can help..."
                value={this.state.content}
                onChange={this.handleMessageChange}
                required={true}
              />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  marginRight: "2.3em",
                  marginTop: "1em"
                }}
              >
                <button className={style.submitButton} type="submit">
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </OutsideClickFinder>
      </div>
    );
  }
}

export default ContactForm;
